import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';

const CurrentMembersPage: React.FC = () => {
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';
  
  const [heroImage, setHeroImage] = useState<string>('');
  const [referralImage, setReferralImage] = useState<string>('');
  const [newspaperIcon, setNewspaperIcon] = useState<string>('');
  const [userFriendsIcon, setUserFriendsIcon] = useState<string>('');
  const [questionCircleIcon, setQuestionCircleIcon] = useState<string>('');
  const [handsHelpingIcon, setHandsHelpingIcon] = useState<string>('');

  useEffect(() => {
    fetch(`${API_URL}/api/images`)
      .then(res => res.json())
      .then(data => {
        console.log('CurrentMembers: Loaded images:', data.images?.length);
        
        const findImage = (filename: string) => {
          const img = data.images?.find((i: any) => 
            i.filename.toLowerCase() === filename.toLowerCase()
          );
          console.log(`Looking for ${filename}:`, img ? 'FOUND' : 'NOT FOUND');
          if (img) {
            console.log(`  URL: ${API_URL}${img.url}`);
          }
          return img ? `${API_URL}${img.url}` : '';
        };

        const hero = findImage('hug.webp');
        const referral = findImage('Refer-A-Friend-Photo.webp');
        const newspaper = findImage('newspaper.webp');
        const userFriends = findImage('userFriends.webp');
        const questionCircle = findImage('questionCircle.webp');
        const handsHelping = findImage('handsHelping.webp');

        console.log('Setting images:', { hero, referral, newspaper, userFriends, questionCircle, handsHelping });

        setHeroImage(hero);
        setReferralImage(referral);
        setNewspaperIcon(newspaper);
        setUserFriendsIcon(userFriends);
        setQuestionCircleIcon(questionCircle);
        setHandsHelpingIcon(handsHelping);
      })
      .catch(err => console.error('Error loading images:', err));
  }, [API_URL]);


  return (
    <div className="current-members-page">
      {/* Red Hero Section with Overlapping Image */}
      <div className="member-care-wrapper">
        <section className="member-care-hero">
          <div className="member-care-container">
            <div className="member-care-content">
              <h1 className="member-care-title">Welcome to the Member Care Hub!</h1>
              <h2 className="member-care-subtitle">Thank You for Being Part of the Alert1 Family</h2>
            </div>
          </div>
        </section>
        
        {/* Separate Image Container - positioned outside the red banner */}
        <div className="member-care-image-container">
          <div className="member-care-image">
            {heroImage ? (
              <img src={heroImage} alt="Member Care" className="member-care-img" />
            ) : (
              <div className="member-care-placeholder">
                <svg width="300" height="300" viewBox="0 0 300 300">
                  <circle cx="150" cy="150" r="145" fill="white" opacity="0.9"/>
                  <circle cx="150" cy="100" r="50" fill="#d32f2f" opacity="0.3"/>
                  <path d="M70 200 Q150 160 230 200" stroke="#d32f2f" strokeWidth="8" fill="none" opacity="0.3"/>
                </svg>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Useful Information Section */}
      <section className="member-info-section">
        <h2 className="member-info-title">Useful Information for Our Valued Members:</h2>
        
        <div className="member-info-content-wrapper">
            {/* Newsletter Section */}
            <div className="member-info-item">
              <div className="member-info-icon" style={{ background: '#999', padding: '15px', borderRadius: '50%', width: '80px', height: '80px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '1rem' }}>
                {newspaperIcon ? (
                  <img src={newspaperIcon} alt="Newsletter" style={{ width: '50px', height: '50px', objectFit: 'contain', display: 'block' }} />
                ) : (
                  <svg width="80" height="80" viewBox="0 0 80 80" fill="none">
                    <circle cx="40" cy="40" r="40" fill="#999"/>
                    <rect x="20" y="25" width="40" height="30" rx="2" fill="white"/>
                    <rect x="25" y="30" width="30" height="3" fill="#999"/>
                    <rect x="25" y="36" width="30" height="3" fill="#999"/>
                    <rect x="25" y="42" width="20" height="3" fill="#999"/>
                  </svg>
                )}
              </div>
              <div className="member-info-text">
                <h3 className="member-info-heading">Stay Informed with Your Monthly Member Newsletter</h3>
                <p className="member-info-description">
                  Be on the lookout for your monthly Member Newsletter, sent via email. You'll discover relevant news 
                  stories, great recipes, and helpful facts—specifically tailored to senior lifestyles.
                </p>
              </div>
            </div>

            {/* Referral Section */}
            <div className="member-info-item member-info-referral">
              <div className="member-info-icon" style={{ background: '#999', padding: '15px', borderRadius: '50%', width: '80px', height: '80px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '1rem' }}>
                {userFriendsIcon ? (
                  <img src={userFriendsIcon} alt="Refer Friends" style={{ width: '50px', height: '50px', objectFit: 'contain', display: 'block' }} />
                ) : (
                  <svg width="80" height="80" viewBox="0 0 80 80" fill="none">
                    <circle cx="40" cy="40" r="40" fill="#999"/>
                    <circle cx="30" cy="35" r="8" fill="white"/>
                    <circle cx="50" cy="35" r="8" fill="white"/>
                    <path d="M20 55 Q30 50 40 55 Q50 50 60 55" stroke="white" strokeWidth="4" fill="none"/>
                  </svg>
                )}
              </div>
              <div className="member-info-text">
                <h3 className="member-info-heading">Refer-A-Friend for Free Service</h3>
                <p className="member-info-description">
                  Do you love a bargain? Participate in our Friends for Life referral program, and <strong>BOTH</strong> you and 
                  your friend will receive one <strong>FREE</strong> month of service if they sign up for a new Alert1 
                  membership. There is no limit to the number of referrals you can make to family, friends, and neighbors!
                </p>
                <Link to="/refer-friend" className="referral-button">KEEP MY FRIEND SAFE</Link>
              </div>
              <div className="member-info-referral-image">
                {referralImage ? (
                  <img src={referralImage} alt="Friends enjoying life" />
                ) : (
                  <div style={{ width: '100%', height: '300px', background: '#f0f0f0', borderRadius: '8px' }}></div>
                )}
              </div>
            </div>
          </div>
      </section>

      {/* Get Help Section */}
      <section className="member-help-section">
        <div className="member-help-container">
          <div className="member-help-item">
            <div className="member-help-icon" style={{ background: '#999', padding: '15px', borderRadius: '50%', width: '80px', height: '80px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '1rem' }}>
              {questionCircleIcon ? (
                <img src={questionCircleIcon} alt="Get Help" style={{ width: '50px', height: '50px', objectFit: 'contain', display: 'block' }} />
              ) : (
                <svg width="50" height="50" viewBox="0 0 50 50" fill="none">
                  <text x="25" y="38" fontSize="40" fill="white" textAnchor="middle" fontWeight="bold">?</text>
                </svg>
              )}
            </div>
            <div className="member-help-text">
              <h3 className="member-help-heading">Get Help</h3>
              <p className="member-help-description">We're here for you!</p>
              <p className="member-help-description">
                For questions about your account, call <strong>Member Care</strong>: 800-693-5433 x 2
              </p>
              <p className="member-help-description">
                For troubleshooting issues, call <strong>Technical Help</strong>: 800-693-5433 x 3
              </p>
            </div>
          </div>

          <div className="member-help-item">
            <div className="member-help-icon" style={{ background: '#999', padding: '15px', borderRadius: '50%', width: '80px', height: '80px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '1rem' }}>
              {handsHelpingIcon ? (
                <img src={handsHelpingIcon} alt="Stay Connected" style={{ width: '50px', height: '50px', objectFit: 'contain', display: 'block' }} />
              ) : (
                <svg width="50" height="50" viewBox="0 0 50 50" fill="none">
                  <path d="M15 20 L25 25 L35 20 M15 20 L15 32 L35 32 L35 20" stroke="white" strokeWidth="2" fill="none"/>
                  <path d="M12 17 L25 25 L38 17" stroke="white" strokeWidth="2" fill="none"/>
                </svg>
              )}
            </div>
            <div className="member-help-text">
              <h3 className="member-help-heading">Stay Connected</h3>
              <p className="member-help-description">
                Keep current on the latest in senior news by following us on social media.
              </p>
              <div className="member-social-icons">
                <a href="https://x.com/Alert1MedAlert" target="_blank" rel="noopener noreferrer" className="member-social-icon" aria-label="X (Twitter)">
                  <svg width="50" height="50" viewBox="0 0 50 50">
                    <circle cx="25" cy="25" r="25" fill="#d32f2f"/>
                    <path d="M37.5 17.3c-.9.4-1.9.7-2.9.8 1.1-.6 1.8-1.6 2.2-2.8-1 .6-2.1 1-3.3 1.2-.9-1-2.2-1.6-3.7-1.6-3.2 0-5.7 3.1-5 6.3-4.3-.2-8.1-2.3-10.6-5.4-1.3 2.3-.7 5.3 1.6 6.9-.8 0-1.6-.3-2.3-.6 0 2.4 1.6 4.6 4.1 5.1-.7.2-1.5.2-2.3.1.7 2 2.5 3.5 4.8 3.6-2.2 1.7-4.9 2.5-7.6 2.1 2.3 1.5 5 2.3 7.9 2.3 9.6 0 15-8.1 14.6-15.3 1-.7 1.9-1.6 2.5-2.7z" fill="white"/>
                  </svg>
                </a>
                <a href="https://www.facebook.com/AlertOne/" target="_blank" rel="noopener noreferrer" className="member-social-icon" aria-label="Facebook">
                  <svg width="50" height="50" viewBox="0 0 50 50">
                    <circle cx="25" cy="25" r="25" fill="#d32f2f"/>
                    <path d="M20.8 16.7h-3.1v4.2h3.1v12.5h5.2V20.9h3.8l.4-4.2h-4.2v-1.7c0-1 .2-1.4 1.2-1.4h3v-5.2h-4c-3.8 0-5.4 1.7-5.4 4.8v3.5z" fill="white"/>
                  </svg>
                </a>
                <a href="https://www.linkedin.com/company/alert1/" target="_blank" rel="noopener noreferrer" className="member-social-icon" aria-label="LinkedIn">
                  <svg width="50" height="50" viewBox="0 0 50 50">
                    <circle cx="25" cy="25" r="25" fill="#d32f2f"/>
                    <path d="M14.6 12.3c-1.4 0-2.4 1.1-2.4 2.4s1 2.4 2.4 2.4c1.4 0 2.4-1.1 2.4-2.4s-1-2.4-2.4-2.4zm-1.8 6.5h3.6v14.9h-3.6V18.8zm5.8 0h3.5v2c.5-1.5 2.4-2.3 4.1-2.3 4.4 0 5.2 2.9 5.2 6.6v8.6h-3.6v-7.6c0-1.8 0-4.1-2.5-4.1s-2.9 2-2.9 4v7.7h-3.6V18.8z" fill="white"/>
                  </svg>
                </a>
                <a href="https://www.youtube.com/user/alert1tv" target="_blank" rel="noopener noreferrer" className="member-social-icon" aria-label="YouTube">
                  <svg width="50" height="50" viewBox="0 0 50 50">
                    <circle cx="25" cy="25" r="25" fill="#d32f2f"/>
                    <path d="M36.3 17.2c-.8-.9-2.3-1.3-4.5-1.4-2.3-.1-5.8-.1-6.8-.1s-4.5 0-6.8.1c-2.2.1-3.7.5-4.5 1.4-.9.9-1.2 2.4-1.3 4.5-.1 2.1-.1 4.8-.1 5.3s0 3.2.1 5.3c.1 2.1.4 3.6 1.3 4.5.8.9 2.3 1.3 4.5 1.4 2.3.1 5.8.1 6.8.1s4.5 0 6.8-.1c2.2-.1 3.7-.5 4.5-1.4.9-.9 1.2-2.4 1.3-4.5.1-2.1.1-4.8.1-5.3s0-3.2-.1-5.3c-.1-2.1-.4-3.6-1.3-4.5zM22.1 30.8v-11.6l9.4 5.8-9.4 5.8z" fill="white"/>
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Thank You Banner */}
      <section className="member-thank-you-banner">
        <div className="member-thank-you-container">
          <h2 className="member-thank-you-title">Thank you again for being a valued member!</h2>
          <p className="member-thank-you-subtitle">With Alert1, you'll never face an emergency alone.</p>
        </div>
      </section>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default CurrentMembersPage;

